import { Expose } from '@nts/std';
import { WidgetGaugeValue } from './widget-gauge-value-dto';

export class WidgetEmptyGaugeValue extends WidgetGaugeValue {

}



